"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-lib/constants/RequestStatusTypes"));

var _handleActions;

var initialState = new _immutable.Map({
  storeUrl: null,
  storeUrlIsValid: false,
  connectionStatus: _RequestStatusTypes.default.UNINITIALIZED,
  isLite: false
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchShopifyUrlValidityActionTypes.SUCCESS, function (state, action) {
  return state.merge({
    storeUrlIsValid: action.payload.data.valid,
    storeUrl: action.payload.props
  });
}), (0, _defineProperty2.default)(_handleActions, _actions.ShopifyConnectionActionTypes.FINISH_SHOPIFY_CONNECTION, function (state) {
  return state.set('connectionStatus', _RequestStatusTypes.default.SUCCEEDED);
}), (0, _defineProperty2.default)(_handleActions, _actions.ShopifyConnectionActionTypes.CHANGE_IS_LITE_STORE, function (state, action) {
  return state.set('isLite', action.payload);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;